import { get as getVideo, createModel } from '.'

export const GET_VIDEO_DATA = 'GET_VIDEO_DATA'
export const SET_VIDEO_DATA = 'SET_VIDEO_DATA'
export const SET_VIDEO_PROCESSING = 'SET_VIDEO_PROCESSING'
export const SET_VIDEO_ID_PATH = 'SET_VIDEO_ID_PATH'
export const SET_VIDEO_END_STATE_TIMER_VISIBLE = 'SET_VIDEO_END_STATE_TIMER_VISIBLE'
export const RESET_VIDEO = 'RESET_VIDEO'

function idIsValid (id, getState) {
  const { video } = getState()
  return video.get('id') === null || video.get('id') === id
}

export function getVideoData ({
  id, path, auth, language,
}) {
  return async function getVideoDataThunk (dispatch, getState) {
    const { video } = getState()
    if (id === video.get('id')) {
      return video
    }
    dispatch(setVideoIdPath(id, path))
    // NOTE: the original call appears to have passed 'path' into the 'auth' parameter
    // 'path' is not used by get (getVideo)
    // const getPromise = get(id, path, auth)
    try {
      const data = await getVideo({ id, auth, language })
      if (idIsValid(data.id, getState)) {
        dispatch(setVideoData(data))
      } else {
        dispatch(setVideoProcessing(false))
      }
      return data
    } catch (_) {
      if (idIsValid(id, getState)) {
        dispatch(setVideoProcessing(false))
      }
      return createModel({}, true)
    }
  }
}

export function setVideoData (data, processing = false) {
  return {
    type: SET_VIDEO_DATA,
    payload: { data, processing },
  }
}

export function setVideoProcessing (value) {
  return {
    type: SET_VIDEO_PROCESSING,
    payload: value,
  }
}

export function setVideoIdPath (id, path, processing = true) {
  return {
    type: SET_VIDEO_ID_PATH,
    payload: { id, path, processing },
  }
}

export function setVideoEndStateTimerVisible (value) {
  return {
    type: SET_VIDEO_END_STATE_TIMER_VISIBLE,
    payload: value,
  }
}

export function resetVideo () {
  return {
    type: RESET_VIDEO,
  }
}
